import { render, staticRenderFns } from "./TemplateMappings.vue?vue&type=template&id=5ebcf3bd&"
import script from "./TemplateMappings.vue?vue&type=script&lang=js&"
export * from "./TemplateMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports